import { PayloadAction } from 'interfaces/action'
import { createPayloadAction } from 'helpers/actionsHelpers'
import { SettingsModalState } from 'interfaces/settings'

// ===========================================================================//
//                                  MEMBER                                    //
// ===========================================================================//

export const SHOW_PASSWORD_CHANGE_FORM = 'SHOW_PASSWORD_CHANGE_FORM' as const
type ShowPasswordChangeForm = PayloadAction<typeof SHOW_PASSWORD_CHANGE_FORM, boolean>
export const showPasswordChangeFormActionCreator = (isShown: boolean) =>
  createPayloadAction(SHOW_PASSWORD_CHANGE_FORM, isShown)

export const SHOW_PROFILE_EDIT_FORM = 'SHOW_PROFILE_EDIT_FORM' as const
type ShowProfileEditForm = PayloadAction<typeof SHOW_PROFILE_EDIT_FORM, boolean>
export const showProfileEditFormActionCreator = (isShown: boolean) =>
  createPayloadAction(SHOW_PROFILE_EDIT_FORM, isShown)

export const SHOW_CONTACT_EDIT_FORM = 'SHOW_CONTACT_EDIT_FORM' as const
type ShowContactEditForm = PayloadAction<typeof SHOW_CONTACT_EDIT_FORM, boolean>
export const showContactEditFormActionCreator = (isShown: boolean) =>
  createPayloadAction(SHOW_CONTACT_EDIT_FORM, isShown)

// ===========================================================================//
//                                    MODAL                                   //
// ===========================================================================//

// god-action! feel the power!!!!1
export const TOGGLE_SETTINGS_MODAL = 'TOGGLE_SETTINGS_MODAL' as const
type ToggleSettingsModal = PayloadAction<typeof TOGGLE_SETTINGS_MODAL, SettingsModalState>
export const toggleSettingsModalActionCreator = (nextModal: SettingsModalState): ToggleSettingsModal =>
  createPayloadAction(TOGGLE_SETTINGS_MODAL, nextModal)

// ===========================================================================//
//                                  HOMES                                     //
// ===========================================================================//

export const TOGGLE_HOME_EDIT = 'TOGGLE_HOME_EDIT' as const
type ToggleHomeEdit = PayloadAction<typeof TOGGLE_HOME_EDIT, number | null>
export const toggleHomeEditActionCreator = (id: number | null): ToggleHomeEdit =>
  createPayloadAction(TOGGLE_HOME_EDIT, id)

// ===========================================================================//
//                                   CARS                                     //
// ===========================================================================//

export const TOGGLE_CAR_EDIT = 'TOGGLE_CAR_EDIT' as const
type ToggleCarEdit = PayloadAction<typeof TOGGLE_CAR_EDIT, number | null>
export const toggleCarEditActionCreator = (id: number | null): ToggleCarEdit =>
  createPayloadAction(TOGGLE_CAR_EDIT, id)


type Action =
  | ShowPasswordChangeForm
  | ShowProfileEditForm
  | ShowContactEditForm

  | ToggleSettingsModal
  | ToggleHomeEdit
  | ToggleCarEdit

export default Action
